import { Switch, Route } from "wouter";
import Landing from "./pages/Landing";
import ClubsList from "./pages/ClubsList";
import ClubDetail from "./pages/ClubDetail";
import Book from "./pages/Book";
import MyBookings from "./pages/MyBookings";
import Login from "./pages/Login";
import { Shell } from "./components/Shell";
import { Link } from "wouter";

export default function App() {
  return (
    <Switch>
      <Route path="/" component={Landing} />
      <Route path="/clubs" component={ClubsList} />
      <Route path="/clubs/:slug" component={ClubDetail} />
      <Route path="/book/:slotId" component={Book} />
      <Route path="/me/bookings" component={MyBookings} />
      <Route path="/login" component={Login} />
      <Route>
        <Shell>
          <div className="mx-auto max-w-xl px-6 py-24 text-center">
            <h1 className="text-4xl font-semibold tracking-tight">Page not found</h1>
            <p className="mt-3 text-neutral-400">The page you’re looking for doesn’t exist.</p>
            <Link href="/" className="mt-6 inline-flex items-center rounded-full bg-accent-500 text-neutral-950 px-5 py-2 text-sm font-medium hover:bg-accent-400 transition-colors">
              Back home
            </Link>
          </div>
        </Shell>
      </Route>
    </Switch>
  );
}
